// React
import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';

// Redux
import { useDispatch } from "react-redux";
import {
  clearSearchedRoutes,
  clearSelectedRoute,
  updateRouteDistance,
  updateSearchLocationFrom,
  updateSearchLocationTo,
  updateShowRouteObjs
} from "../slices";


// Internal imports
// import { HeaderHeightContext } from '../App';

// External Imports
import { DndProvider } from 'react-dnd-multi-backend';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import { useMediaQuery } from '@uidotdev/usehooks';

import { shortenToOneDecimal } from "../Components/data/routes";
import MapWrapper from '../Components/map/MapWrapper';

// Styling
import '../Components/map/Map.scss';

export default function MapPage() {
  /* Setup */
  // Redux
  const dispatch = useDispatch();

  // Navigation
  const location = useLocation();
  const { id: cameraPathId } = useParams();
  const [searchParams] = useSearchParams();
  // Snapshot before map navigations replace location.state (path string or false)
  const fromCameraList = useRef(location.state?.fromCameraList || false).current;

  document.title = 'DriveBC';

  const getReferenceParams = () => {
    if (cameraPathId) {
      return {
        type: 'camera',
        id: cameraPathId,
        display_category: null,
      };
    }

    return {
      type: searchParams.get('type'),
      id: searchParams.get('id'),
      display_category: searchParams.get('display_category'),
    };
  }
  const [referenceData, setReferenceData] = useState(null);

  // Effects
  useEffect(() => {
    setReferenceData(getReferenceParams());
  }, [searchParams, cameraPathId]);

  useEffect(() => {
    populateRoutesFromNotification();
  }, []);

  /* Helpers */
  const populateRoutesFromNotification = async () => {
    // DBC22-3396: populate route data from notifications
    const routeData = {
      route_start: searchParams.get('route_start'),
      route_start_point: searchParams.get('route_start_point'),
      route_end: searchParams.get('route_end'),
      route_end_point: searchParams.get('route_end_point'),
      route_distance: searchParams.get('route_distance'),
    }

    if (routeData.route_distance) {
      dispatch(clearSearchedRoutes());
      dispatch(clearSelectedRoute());
      dispatch(updateRouteDistance(shortenToOneDecimal(parseFloat(routeData.route_distance))));
      dispatch(updateShowRouteObjs(true));

      // Start point
      const route_start_coords = [
        parseFloat(routeData.route_start_point.split(',')[0]),
        parseFloat(routeData.route_start_point.split(',')[1])
      ];

      const start_point = [{
        geometry: {
          type: 'Point',
          coordinates: route_start_coords
        },
        label: routeData.route_start
      }];

      dispatch(updateSearchLocationFrom(start_point));

      // End point
      const route_end_coords = [
        parseFloat(routeData.route_end_point.split(',')[0]),
        parseFloat(routeData.route_end_point.split(',')[1])
      ];

      const end_point = [{
        geometry: {
          type: 'Point',
          coordinates: route_end_coords
        },
        label: routeData.route_end
      }];

      dispatch(updateSearchLocationTo(end_point));
    }
  }

  // const { headerHeightContext } = useContext(HeaderHeightContext);

  const smallScreen = useMediaQuery('only screen and (max-width: 575px)');

  /* Rendering */
  // Main component
  return (
    <DndProvider options={HTML5toTouch}>
      <div className="map-page map-wrap">
        {referenceData &&
          <MapWrapper referenceData={referenceData} fromCameraList={fromCameraList} />
        }
      </div>
    </DndProvider>
  );
}
